<div class="headmod" [ngStyle]="{ 'background-color': getMainColor() }">
    Set cruise spaces on hold
    <p>Place on Hold</p>
</div>

<div class="mod-content active">
    <div id="no-more-tables" *ngIf="initialized">
        <div *ngIf="this.dataCompany.maximumCabinOnHold===0" class="no-available">
            <h2>This option is not available</h2>
            <br>
            <div class="home">
                <a (click)="goBack()">Go back</a>
            </div>
        </div>
        <div *ngIf="this.dataCompany.maximumCabinOnHold!==0">

            <form [formGroup]="cabinForms" (change)="this.setRemainingAdults(); this.cabinFormChanged()"
                [ngClass]="hasEmailRequest ? 'disabled' : ''">
                <table class="onhold" formArrayName="cabinForms"
                    *ngFor="let cabinForm of getArrayControls(); let i = index">
                    <thead>
                        <tr>
                            <th scope="col">Select Cabin Type:</th>
                            <th scope="col" colspan="2">Number of Passengers:</th>
                            <th scope="col">Price per person:</th>
                            <th scope="col">&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr [formGroupName]="i" class="item">
                            <td data-title='Cabin:'>
                                <div class="form-grp2"
                                    [ngClass]=" { 'has-error': ( ( cabinForm.get('cabinaItinerarioMenor').touched || cabinForm.get('cabinaItinerarioMenor').dirty ) && cabinForm.get('cabinaItinerarioMenor').invalid ) } ">
                                    <select class="textselect form-control select_cabin_gm"
                                        (change)="addLogCabins(this.webFlowAction.ON_HOLD_SELECTED_CABIN); setBedType(i)"
                                        formControlName="cabinaItinerarioMenor">
                                        <option [value]="-1">Select a Cabin</option>
                                        <option
                                            *ngFor="let cabina of this.getFilteredCabinaItinerarioMenorWrapper( i ); let i = index"
                                            [disabled]="cabina.selected" value="{{ i }}">
                                            {{ cabina.cabina.getCabinaFullName() }} {{ cabina.selected === true ?
                                            '(Selected)' : '' }}
                                        </option>
                                    </select>
                                </div>
                            </td>


                            <input type="hidden" name="camaCabinaList" formControlName="camaCabinaList"
                                id="camaCabinaList">


                            <td data-title='# of Adults:'>
                                <div class="form-grp2"
                                    [ngClass]=" { 'has-error': ( ( cabinForm.get('adults').touched || cabinForm.get('adults').dirty ) && cabinForm.get('adults').invalid )|| cabinForm.invalid } ">
                                    <select class="form-control select_num_passenger_gm" formControlName="adults"
                                        (change)="addLogCabins(this.webFlowAction.ON_HOLD_SELECTED_CABIN)"
                                        *ngIf="!this.cabinForm.get('camaCabinaList').invalid && !this.cabinForm.get('cabinaItinerarioMenor').invalid"
                                        style=" display: inline-block; " id="adults_{{ i }}">
                                        <option disabled selected>Adults</option>
                                        <option [value]="adultElement"
                                            *ngFor="let adultElement of this.getNumberOfAdultsAsArray( i )"> {{
                                            adultElement }}</option>
                                    </select>
                                    <select class="form-control select_num_passenger_gm"
                                        (change)="addLogCabins(this.webFlowAction.ON_HOLD_SELECTED_CABIN)"
                                        *ngIf="this.cabinForm.get('camaCabinaList').invalid || this.cabinForm.get('cabinaItinerarioMenor').invalid"
                                        disabled="true" style=" display: inline-block; " id="adults_{{ i }}">
                                        <option disabled selected>Adults</option>
                                        <option [value]="adultElement"
                                            *ngFor="let adultElement of this.getNumberOfAdultsAsArray( i )"> {{
                                            adultElement }}</option>
                                    </select>
                                </div>
                            </td>
                            <td data-title='# of Children:'>
                                <div class="form-grp2"
                                    [ngClass]=" { 'has-error': ( ( cabinForm.get('children').touched || cabinForm.get('children').dirty ) && cabinForm.get('children').invalid ) || cabinForm.invalid} ">
                                    <select class="form-control select_num_children_gm" id="children_{{ i }}"
                                        formControlName="children"
                                        *ngIf="!this.cabinForm.get('camaCabinaList').invalid && !this.cabinForm.get('cabinaItinerarioMenor').invalid && true "
                                        style=" display: inline-block; "
                                        [attr.disabled]="disableChildren ? true : null">
                                        <option disabled selected value="-1">Children</option>

                                        <option [value]="childElement"
                                            *ngFor="let childElement of this.getNumberOfChildrenAsArray( i )">{{
                                            childElement }}</option>
                                    </select>
                                    <select class="form-control select_num_children_gm" id="children_{{ i }}"
                                        formControlName="children"
                                        *ngIf="this.cabinForm.get('camaCabinaList').invalid || this.cabinForm.get('cabinaItinerarioMenor').invalid || !true"
                                        disabled="true" style=" display: inline-block; ">
                                        <option disabled selected value="-1">Children</option>
                                        <option [value]="childElement"
                                            *ngFor="let childElement of this.getNumberOfChildrenAsArray( i )">{{
                                            childElement }}</option>
                                    </select>
                                </div>
                            </td>
                            <td class="price" data-title='Price:'>
                                <b id="precio1"><span id="cabin1" *ngIf="this.getPrice( i )">US${{ this.getPrice( i
                                        )?.toLocaleString('en',{maximumFractionDigits:2}) }}</span></b>
                                <p class="text-center" *ngIf=" !this.getPrice( i ) ">US$ </p>
                            </td>
                            <td class="del">
                                <a class="delete" (click)="deleteCabinForm(i)" *ngIf="i!==0">
                                    <img src="assets/images/trash.png" width="20" height="22" alt="Delete"
                                        title="Delete"></a>
                            </td>
                        </tr>
                        <tr *ngIf=" ( this.cabinForms.get('cabinForms').get( i.toString() ).touched
                            || this.cabinForms.get('cabinForms').get( i.toString() ).dirty )
                            && this.cabinForms.get('cabinForms').get( i.toString() ).invalid
                            && (  this.cabinForms.get('cabinForms').get( i.toString() ).hasError('exceededCapacity')
                            || this.cabinForms.get('cabinForms').get( i.toString() ).hasError('childrenWithoutAdult') )"
                            style=" border-bottom: 10px solid #fff; ">
                            <td colspan="5" class="bg-warning text-danger" style="padding: 10px;">
                                <ul class="list-unstyled" style=" font-size: .9em; margin-bottom: 0; ">
                                    <li
                                        *ngIf=" ( this.cabinForms.get('cabinForms').get( i.toString() ).touched || this.cabinForms.get('cabinForms').get( i.toString() ).dirty ) && this.cabinForms.get('cabinForms').get( i.toString() ).hasError('exceededCapacity') ">
                                        This cabin only accepts {{ this.cabinForms.get('cabinForms').get( i.toString()
                                        ).getError('exceededCapacity').capacity }} passengers{{
                                        this.cabinForms.get('cabinForms').get( i.toString()
                                        ).getError('exceededCapacity').capacityAdults > 1 ? 's' : '' }}
                                        but you have selected {{ this.cabinForms.get('cabinForms').get( i.toString()
                                        ).getError('exceededCapacity').selectedPassengers }}.
                                    </li>
                                    <li
                                        *ngIf=" ( this.cabinForms.get('cabinForms').get( i.toString() ).touched || this.cabinForms.get('cabinForms').get( i.toString() ).dirty ) && this.cabinForms.get('cabinForms').get( i.toString() ).hasError('childrenWithoutAdult') ">
                                        You must select at least one adult for this cabin.
                                    </li>
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="row">

                    <tr style=" border-bottom: 10px solid #fff; ">
                        <td colspan="5" class="bg-warning text-danger" style="padding: 10px;">
                            <ul class="list-unstyled" style=" font-size: .9em; margin-bottom: 0; ">

                                <li
                                    *ngIf="this.cruise.availability[this.cruise.iterIndex].groupsOnly && cabinForms.invalid">
                                    Group departure only ( a minimum of {{numberOfPassengers}} passengers is required)

                                </li>
                            </ul>
                        </td>

                    </tr>
                </div>
                <a class="lngnext" id="pluscabin" (click)="addCabinForm()"
                    [ngClass]="( !isValidRowsCabin()) ? 'disabled' : ''"
                    [ngStyle]="{ 'background-color': getSecundaryColor() }">
                    <img src="assets/images/plus.png" width="20" height="20" alt=""> Add a Cabin
                </a>
            </form>
            <hr class="dotted">
            <h3>Contact Information</h3>
            <form class="needs-validation" (ngSubmit)="save()" [formGroup]="formGroupOnHold"
                [ngClass]="hasEmailRequest ? 'disabled' : ''">
                <div class="form-grp">
                    <label for="email">E-mail (*):</label>
                    <input formControlName="email" id="Email" maxlength="300" name="email"
                        (focusout)="addLog(this.webFlowAction.ON_HOLD_PASSENGER_INFORMATION)"
                        pattern="^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,3})$" type="text"
                        class="form-control" [class.is-invalid]="getValid('email')" required email />
                    <div *ngIf="getValid('email')" class="text-danger">
                        <div *ngIf="getValid('email')">Email is required*</div>
                    </div>
                </div>
                <div class="form-grp" style="overflow: visible !important;">
                    <label for="telephone">Telephone: </label>
                    <!--<input formControlName="telephone" id="telephone" maxlength="300" name="telephone"
                        (focusout)="addLog(this.webFlowAction.ON_HOLD_PASSENGER_INFORMATION)" type="text"
                        class="form-control" />-->
                    <ngx-intl-tel-input [cssClass]="'custom'" class="form-control"
                        [preferredCountries]="[CountryISO.UnitedStates, CountryISO.UnitedKingdom]"
                        [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
                        formControlName="itiObject"
                        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                        [selectFirstCountry]="true" [selectedCountryISO]="CountryISO.UnitedStates" [maxLength]="15"
                        [phoneValidation]="false" name="telephone" id="Telephone"
                        [separateDialCode]="true"></ngx-intl-tel-input>
                </div>
                <div class="form-grp">
                    <label for="reference">Reference Name(*):</label>
                    <input formControlName="reference" id="reference" maxlength="300" name="reference" type="text"
                        (focusout)="addLog(this.webFlowAction.ON_HOLD_PASSENGER_INFORMATION)"
                        [class.is-invalid]="getValid('reference')" class="form-control" required />
                    <div *ngIf="getValid('reference')" class="text-danger">
                        <div *ngIf="getValid('reference')">Reference is required*</div>
                    </div>
                </div>
                <div class="form-grp">
                    <label for="agency">Agency Name (if applicable):</label>
                    <input formControlName="agency" id="agency" maxlength="300" name="agency"
                        (focusout)="addLog(this.webFlowAction.ON_HOLD_PASSENGER_INFORMATION)" type="text"
                        class="form-control" />
                </div>
                <div class="form-grp2">
                    <label for="remarks">Any Questions, Comments or Special Requests:</label>
                    <textarea class="comments" formControlName="remarks" style="padding-right: 3px;" cols="70"
                        (focusout)="addLog(this.webFlowAction.ON_HOLD_PASSENGER_INFORMATION)" maxlength="1000"
                        name="comments" rows="5" wrap="physical">
            </textarea>
                </div>
                <div class="row">
                    <p>Mandatory fields (*):</p>
                </div>
                <div class="row-cuaquier">
                    <a class="lngnext" (click)="save()" *ngIf="!isLoading"
                        [ngStyle]="{ 'background-color': getSecundaryColor() }"
                        [ngClass]="cabinForms.invalid ||  formGroupOnHold.invalid? 'disabled' : ''">Send</a>

                    <div style="text-align: center;" *ngIf="isLoading">
                        <img src="assets/images/sending.gif" alt="sending" width="5%">
                    </div>
                </div>
                <hr class="dotted">
            </form>
            <div *ngIf="hasEmailRequest">
                <h2 *ngIf="this.codeError!=='201'">
                    {{messageCode}}</h2>
                <h1 *ngIf="codeError=='201'" style="color: #800011;">
                    Your email address already register a hold request. Please Contact your account manager
                </h1>
                <p *ngIf="codeError!=='201'">
                    Please enter the verification code below
                </p>
                <a href="javascript:void()" (click)="save()" *ngIf="codeError!=='201'">Send code again </a>
                <br *ngIf="codeError!=='201'">
                <a href="javascript:void()" (click)="hasEmailRequest=false">Modify information </a>

                <app-code-verification (codeEntered)="setCodeEntered($event)"
                    *ngIf="token!==null"></app-code-verification>
                <a class="lngnext" (click)="blockCabin()" [ngStyle]="{ 'background-color': getSecundaryColor()}"
                    style="margin-top: 5px;"
                    *ngIf="!cabinForms.invalid && !formGroupOnHold.invalid && !isLoadingOnHold && token!==null">On
                    hold</a>
                <div style="text-align: center;" *ngIf="isLoadingOnHold">
                    <img src="assets/images/sending.gif" alt="sending" width="5%">
                </div>

            </div>
        </div>


        <p style="text-align: center; margin-top: 30px;"><em><strong _ngcontent-c1="">Important: </strong>Certain
                filters and security settings may prevent our emails (responses) from arriving in your inbox so please
                be sure to check your junk, trash or spam folders.</em></p>
    </div>
    <div id="no-more-tables" *ngIf="!initialized">
        <app-loading [dataCompany]="dataCompany"></app-loading>
    </div>
</div>
<gal-modal [visible]="isVisibleDialog" [closable]="true" [modalWidth]="'30vw'" (modalClosed)="isVisibleDialog=false">
    <div class="content-modal">
        <div class="title-modal">
            <img src="assets/images/icons/alert.png" alt="alert" width="40px">
        </div>
        <div class="message-modal">
            <p>{{dialogObj?.message}}</p>
        </div>
        <div class="row" style="text-align: end;">
            <button style="background-color: #0095ff; color: white; text-align: end;" color="warn" mat-button
                (click)="isVisibleDialog=false">
                <b>
                    Accept
                </b>
            </button>
        </div>
    </div>
</gal-modal>